import { HttpBackend, HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterOutlet } from '@angular/router';
import { AngularSharedFeatureAppFrameModule } from '@herrenknecht-connected/angular-shared-feature-app-frame';

import {
  CommonApplicationModuleProviders,
  ConnectedMissingTranslationHandler,
  ManualBreakpointService,
  SimplifiedConnectedBreakpointService,
} from '@herrenknecht-connected/angular-shared-utils-core';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { LoggerModule } from 'ngx-logger';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { environment } from '../environments/environment';
import { StatusRoutingModule } from './status-ui-routing.module';
import { StatusComponent } from './status-ui.component';
import { StatusOverviewComponent } from './pages/overview/status-overview.component';
import { EmergencyContactComponent } from './components/emergency-contact/emergency-contact.component';
import { NewsComponent } from './components/news/news.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import {
  CenteredMatSpinnerComponent,
  HKButtonDirective,
  IconWithLabelComponent,
  LayoutContainerComponent,
  MenuItemComponent,
  OverviewCardComponent,
} from '@herrenknecht-connected/angular-shared-ui-base-components';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

@NgModule({
  declarations: [StatusComponent, StatusOverviewComponent, EmergencyContactComponent, NewsComponent],
  imports: [
    BrowserModule,
    AngularSharedFeatureAppFrameModule,

    MatMenuModule,
    LoggerModule.forRoot({ level: environment.consoleLogLevel, serverLogLevel: environment.serverLogLevel }),
    TranslateModule.forRoot({
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: ConnectedMissingTranslationHandler },
      loader: {
        provide: TranslateLoader,
        useFactory: (httpBackend: HttpBackend) => new MultiTranslateHttpLoader(httpBackend, ['assets/status/i18n/', 'assets/shared/i18n/']),
        deps: [HttpBackend],
      },
      extend: true,
    }),
    BrowserAnimationsModule,
    HttpClientModule,
    NgxWebstorageModule.forRoot(),
    RouterOutlet,
    StatusRoutingModule,
    MatButtonModule,
    IconWithLabelComponent,
    MenuItemComponent,
    OverviewCardComponent,
    HKButtonDirective,
    CenteredMatSpinnerComponent,
    LayoutContainerComponent,
  ],
  providers: [
    CommonApplicationModuleProviders.getHttpCache(),
    CommonApplicationModuleProviders.getHttpClientWithDiAndCache(),
    { provide: SimplifiedConnectedBreakpointService, useExisting: ManualBreakpointService },
    CommonApplicationModuleProviders.getAppNameValueProvider('status-ui'),
    CommonApplicationModuleProviders.getSessionIdAppInitializerProvider(),
    CommonApplicationModuleProviders.getCheckUserAgentAppInitializerProvider(),
    CommonApplicationModuleProviders.getTranslationsAppInitializer(),
    { provide: LOCALE_ID, useValue: 'en' },
  ],
  bootstrap: [StatusComponent],
})
export class StatusUiModule {}
